module.exports = __webpack_public_path__ + "static/media/3DPPA31.6da7366b.jpg";